import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ticket-graphic-footer',
  templateUrl: './ticket-graphic-footer.component.html',
  styleUrls: ['./ticket-graphic-footer.component.scss'],
})
export class TicketGraphicFooterComponent implements OnInit {
  
  @Input()
  padding: number = 40;

  constructor() { }

  getPadding(): string {
    return `0 ${this.padding}px`;
  }

  ngOnInit() {}

}
